import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type PhonicPlayerStyles = {
  outerDiv: CSSProperties;
  playingColor: CSSProperties;
};

export const phonicPlayerStyles: PhonicPlayerStyles = {
  outerDiv: {
    width: "100%",
    height: "100%",
    ...cssClass.centerFlex,
    flexDirection: "column",
    overflow: "hidden",
    color: backgroundColors.gray,
    fontSize: "1.8rem",
    ...cssClass.button,
    ...cssClass.bigRadius,
  },
  playingColor: {
    color: backgroundColors.orange,
  },
};
